<div class="form-row">
  <div class="form-group col-md-6" [formGroup]="createUserFormGroup">
    <label for="timezone">{{ 'content.timezone' | translate }} *
      <select #timeZoneInput id="timezone" class="form-select" formControlName="timeZone">
        <option selected value="">{{ 'content.timezone-select' | translate }}</option>
        @for (timeZone of timeZones | keyvalue; track timeZone) {
          <option [value]="timeZone.key">{{ timeZone.value }}</option>
        }
      </select>
    </label>
    <app-validation-errors [displayErrors]="userFormSubmitted" [errors]="createUserFormGroup.controls.timeZone.errors"></app-validation-errors>
  </div>
</div>

@if (daysOfWeek) {
  <div>
    @for (day of shortDaysOfWeek; track day) {
      <div>
        <app-day-access-time
          [dayShort]="day"
          [dayFull]="daysOfWeek.get(day)"
          [allowedTimesFormGroup]="allowedTimesFormGroup"
          [userFormSubmitted$]="userFormSubmitted$"
          (applyTimeToAll)="applyTimeToAll($event)">
        </app-day-access-time>
      </div>
    }
  </div>
}
